import WorkspaceBig from 'components/utilized/studentDashboard/WorkspaceBig'
import WorkspaceSmall from 'components/utilized/studentDashboard/WorkspaceSmall'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'redux/store'
import { setLessonPlanBackUrl } from 'redux/ui/lessonPlansUI'
import { setSessionBackUrl } from 'redux/ui/sessionsUI'
import { isSmallStudent } from 'utils/helpers'

const StudentWorkspacePage = () => {
  const dispatch = useDispatch<AppDispatch>()
  const user = useSelector((state: RootState) => state['user'].user)

  useEffect(() => {
    dispatch(setSessionBackUrl(`/student-workspace`))
  }, [])


  return (
    <div>
        {isSmallStudent(user) && <WorkspaceSmall />} 
        {!isSmallStudent(user) && <WorkspaceBig />} 
    </div>
  )
}
export default StudentWorkspacePage
